/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Feature_Free_1Inputs */



/**
* | output |
* | --- |
* | "Full caption editor with timeline and automatic QC" |
*
* @param {Signup_Feature_Free_1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_free_1 = /** @type {((inputs?: Signup_Feature_Free_1Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Free_1Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Full caption editor with timeline and automatic QC")
	if (locale === "de") return /** @type {LocalizedString} */ ("Full caption editor with timeline and automatic QC")
	if (locale === "it") return /** @type {LocalizedString} */ ("Full caption editor with timeline and automatic QC")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Full caption editor with timeline and automatic QC")
	if (locale === "es") return /** @type {LocalizedString} */ ("Full caption editor with timeline and automatic QC")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Full caption editor with timeline and automatic QC")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Full caption editor with timeline and automatic QC")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Full caption editor with timeline and automatic QC")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Full caption editor with timeline and automatic QC")
	return /** @type {LocalizedString} */ ("Full caption editor with timeline and automatic QC")
});